import { useApolloClient, useQuery, gql} from '@apollo/client';

const GET_CONFIGS = gql`
query Configs {
    configs(filters: {display_enabled: {eq: true}}, pagination: {limit: -1}){
        data {
            attributes {
                config_name
                config_category
                end_date
                start_date
                card_front
                card_back
                category_icon{
                    data{
                        attributes{
                            url
                        }
                    }
                }
                type
            }
        }
    }
    banners(filters: {display_enabled: {eq: true}}, pagination: {limit: -1}) {
        data {
            attributes {
                description
                color
                download_buttons
                start_date
                end_date
                banner_desktop_1920w {
                    data {
                        attributes {
                            url
                        }
                    }
                }
                banner_tab_780w {
                    data {
                        attributes {
                            url
                        }
                    }
                }
                banner_mobile_540w {
                    data {
                        attributes {
                            url
                        }
                    }
                }
            }
        }
    }
    appImages (pagination: {limit: -1}){
        data {
            attributes {
                section
                description
                media_file {
                    data {
                        attributes {
                            url
                        }
                    }
                }
            }
        }
    }
    simTariffs(sort: "display_order:asc"){
        data {
            attributes {
                tariff_name
                recommended
                tariff_description
                tariff_card_name
            }
        }
    }
    services (filters: {display_enabled: {eq: true}}, pagination: {limit: -1}, sort: "display_order:asc"){
        data {
            attributes {
                service_name
                service_detail
                slider_type
                section_color
                slider_bg_color
                slider_display_order
                slider_image {
                    data {
                        attributes {
                            url
                        }
                    }
                }
                service_image {
                    data {
                        id
                        attributes {
                            url
                        }
                    }
                }
                service_tabs(filters: {display_enabled: {eq: true}}) {
                    data {
                        attributes {
                            tab_name
                            tab_detail
                        }
                    }
                }
                service_accordions(filters: {display_enabled: {eq: true}}, pagination: {limit: -1}) {
                    data {
                        attributes {
                            tab_name
                            tab_detail
                            media_url
                            service_nested_accordions(filters: {display_enabled: {eq: true}}, pagination: {limit: -1}) {
                                data {
                                    attributes {
                                        tab_name
                                        tab_detail
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    promotions (filters: {display_enabled: {eq: true}}, pagination: {limit: -1}, sort: "display_order:asc"){
        data {
            attributes {
                promotion_name
                promo_detail
                section_color
                promo_icon {
                    data {
                        attributes {
                            url
                        }
                    }
                }
                promo_image {
                    data {
                        id
                        attributes {
                            url
                        }
                    }
                }
                promotion_tabs (filters: {display_enabled: {eq: true}}) {
                    data {
                        attributes {
                            tab_name
                            tab_detail
                            card_color
                            font_color
                            title_color
                            promotion_tab_details (pagination: {limit: -1}){
                                data{
                                    attributes{
                                        title
                                        details
                                    }
                                }
                            }
                        }
                    }
                }
                promotion_accordions(filters: {display_enabled: {eq: true}}, pagination: {limit: -1}) {
                    data {
                        attributes {
                            tab_name
                            tab_detail
                            media_url
                        }
                    }
                }
                promotion_details (pagination: {limit: -1}){
                    data {
                        attributes {
                            title
                            details
                        }
                    }
                }
            }
        }
    }
    bundles(filters: {display_enabled: {eq: true}}, pagination: {limit: -1}) {
        data {
            id
            attributes {
                bundle_name_en
                bundle_name_ar
                validity
                bundle_attributes
                price
                display_order
                bundle_type {
                    data {
                        id
                        attributes {
                            bundle_type_name
                            tax_type
                            sub_category
                        }
                    }
                }
                sub_category
                featured
                ussd_code
                start_date
                end_date
            }
        }
    }
    bundleTypes(sort: "display_order:asc"){
        data {
            attributes {
                bundle_type_name
                tax_type
                sub_category
            }
        }
    }
    appIcons (filters:{display_enabled: {eq: true}}, pagination: {limit: -1}) {
        data {
            attributes {
                icon_code
                icon_name
                icon_image {
                    data {
                        attributes {
                            url
                        }
                    }
                }
            }
        }
    }
    benefits (filters: {display_enabled: {eq: true}}, pagination: {limit: -1}, sort: "display_order:asc") {
        data {
            attributes {
                card_description
                benefit_name
                icon{
                    data{
                        attributes{
                            url
                        }
                    }
                }
            }
        }
    }
    offers (filters: {display_enabled: {eq: true}}, pagination: {limit: -1}, sort: "display_order:asc") {
        data {
            attributes {
                offer_name
                start_date
                end_date
                hover_text
                destination_link
                banner_image{
                    data{
                        attributes{
                            url
                        }
                    }
                }
            }
        }
    }
    btlOffers {
        data {
            attributes {
                page_title
                page_text
                btl_table
            }
        }
    }
    ceoSpeak {
        data {
            attributes {
                title
                content
            }
        }
    }
    rechargeTAndC {
        data {
            attributes {
                title
                content
            }
        }
    }
    termsNCondition {
        data {
            attributes {
                title
                content
            }
        }
    }
    
}
`;

export const useConfigsQuery = () => {
    const client = useApolloClient();
    const { loading, error, data } = useQuery(GET_CONFIGS, {
      client: client,
    });
    return { loading, error, data };
  };